export const CN_STATUSES = {
  BLOCKED: 'BLOCKED',
  UNBLOCKED: 'UNBLOCKED',
  RTO: 'RTO'
};

export const DamageCnDashboardFailureMessages = {
  GET_CN_FAIL: 'Could not fetch Damage/Pilferage blocked CNs'
};
